/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import CategoryIcon from "@material-ui/icons/Category";
import ClassIcon from "@material-ui/icons/Class";
import PublicIcon from "@material-ui/icons/Public";
import ArtTrackIcon from "@material-ui/icons/ArtTrack";
import DescriptionIcon from "@material-ui/icons/Description";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import LanguageIcon from "@material-ui/icons/Language";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import CropFreeIcon from "@material-ui/icons/CropFree";
import { shallowEqual, useSelector } from "react-redux";

export function AsideMenuList({ layoutProps }) {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        <li className="menu-section">
          <h4 className="menu-text">CATALOGUE</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/products",
            false
          )} ${getMenuItemActive("/edit-product", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/products">
            <span className="menu-icon">
              <ArtTrackIcon />
            </span>
            <span className="menu-text">Products</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/categories",
            false
          )} ${getMenuItemActive("/edit-category", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/categories">
            <span className="menu-icon">
              <CategoryIcon />
            </span>
            <span className="menu-text">Categories</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/types",
            false
          )} ${getMenuItemActive("/edit-type", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/types">
            <span className="menu-icon">
              <ClassIcon />
            </span>
            <span className="menu-text">Types</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/brands",
            false
          )} ${getMenuItemActive("/edit-brand", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/brands">
            <span className="menu-icon">
              <PublicIcon />
            </span>
            <span className="menu-text">Brands</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/formats",
            false
          )} ${getMenuItemActive("/edit-format", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/formats">
            <span className="menu-icon">
              <LocalBarIcon />
            </span>
            <span className="menu-text">Formats</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/downloads",
            false
          )} ${getMenuItemActive("/edit-download", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/downloads">
            <span className="menu-icon">
              <CloudDownloadIcon />
            </span>
            <span className="menu-text">Downloads</span>
          </NavLink>
        </li>
        <li className="menu-section">
          <h4 className="menu-text">USERS</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/contacts",
            false
          )} ${getMenuItemActive("/edit-contact", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/contacts">
            <span className="menu-icon">
              <ContactMailIcon />
            </span>
            <span className="menu-text">Contacts</span>
          </NavLink>
        </li>
        {user.role === "admin" && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/admins",
              false
            )} ${getMenuItemActive("/edit-admin", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/admins">
              <span className="menu-icon">
                <AssignmentIndIcon />
              </span>
              <span className="menu-text">Administrators</span>
            </NavLink>
          </li>
        )}

        <li className="menu-section">
          <h4 className="menu-text">MISCELLANY</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/languages",
                false
              )} ${getMenuItemActive("/edit-language", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/languages">
                <span className="menu-icon">
                  <LanguageIcon />
                </span>
                <span className="menu-text">Languages</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/texts",
                false
              )} ${getMenuItemActive("/edit-text", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/texts">
                <span className="menu-icon">
                  <DescriptionIcon />
                </span>
                <span className="menu-text">Texts</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/QRs",
                false
              )} ${getMenuItemActive("/edit-QR", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/QRs">
                <span className="menu-icon">
                  <CropFreeIcon />
                </span>
                <span className="menu-text">QRs</span>
              </NavLink>
            </li>
          </>
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
